@if (checkoutSummary$ | withLoading | async; as result) {
  @if (result.loading) {
    <app-spinner-filled />
  } @else {
    @let items = result.value?.items;
    @let details = result.value?.details;

    @if (isNotEmpty(items)) {
      <div class="grid grid-cols-1 gap-8 lg:grid-cols-2 xl:grid-cols-9">
        <div class="order-2 lg:order-1 xl:col-span-5">
          <app-public-checkout-form
            (submitSuccessEvent)="handleSubmitEvent($event)" />
        </div>

        <div class="order-1 lg:order-2 xl:col-span-4">
          <app-public-order-checkout-summary
            [shippingMethod]="details?.shipping?.method?.name"
            [shippingMethodDescription]="details?.shipping?.method?.description"
            (discountCodeSubmitEvent)="handleDiscountCodeSubmitEvent($event)"
            [deliveryCosts]="valueOrDefault(details?.shipping?.price, 0)"
            [deliveryQuantity]="valueOrDefault(details?.shipping?.quantity, 0)"
            [deliveryUnitPrice]="
              valueOrDefault(details?.shipping?.unitPrice, 0)
            "
            [discount]="valueOrDefault(details?.discount, null)"
            [recursive]="valueOrDefault(details?.recursive, [])"
            [items]="items"
            [cartTotalCosts]="
              valueOrDefault(details?.summary?.totalItemsPrice, 0)
            "
            [totalCosts]="valueOrDefault(details?.summary?.totalPrice, 0)" />
        </div>
      </div>
    } @else {
      <app-public-cart-empty />
    }
  }
}
